import React, { useEffect,useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import TopNavbar from "./TopNavbar";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import ExcelUpload from "./ExcelUpload";
import { urlbc } from "../components/Constants";


const MarkupSheet = () => {

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [userRole, setRole] = useState("");
  
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };


  const navigate = useNavigate();
  // const [items, setItems] = useState([]);
  const token = localStorage.getItem("TOKEN");
  useEffect(() => {
    // Check the role on page load
    const userRole = localStorage.getItem('ROLE');
    setRole(userRole);

    if (userRole !== 'superadmin') {
      navigate('/'); // Redirect to signin if not superadmin
    }
  }, [navigate]);

  useEffect(() => {
    if (!token) {
      navigate("/signin");
    }
  });

  useEffect(() => {
    axios
      .get(`${urlbc}/booking`)
      .then((respone) => {
        // setItems(respone.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

    // below error not come in terminal
    console.log(userRole)

  return (
    <>
      <div className="container-fluid position-relative d-flex p-0">
      <Sidebar isSidebarOpen={isSidebarOpen} />
      <div className={`content ${isSidebarOpen ? 'open' : ''}`}>
        <TopNavbar toggleSidebar={toggleSidebar} />
          <div className="container-fluid pt-4 px-4">
          <ExcelUpload />
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default MarkupSheet;
